import { UserError, SystemError, ApplicationError } from './application-error'
import { ExecutionResult } from 'graphql'

export function makeGraphUserError<T>(data: ExecutionResult<T>): UserError {
  const message =
    data.errors?.map((error) => error.message).join(', ') || 'Unknown error'
  const err = data.errors?.[0]
  const operationName = err?.path?.join(',') || err?.name

  return new UserError(message, {
    errors: data.errors,
    extensions: data.extensions,
    operationName,
  })
}

export function makeGraphServerError(res: Response): SystemError | UserError {
  const message = res.statusText || 'Unknown error'
  const operationName = res.url?.split('?')?.[1] || 'UnknownOperation'

  if (res.status >= 400 && res.status < 500) {
    return new UserError(res.statusText, {
      httpStatusCode: res.status,
      originalError: new Error(res.statusText),
      operationName,
    })
  }

  return new SystemError(message, {
    httpStatusCode: res.status,
    originalError: new Error(res.statusText),
    operationName,
  })
}

export async function handleGraphResponse<Data>(res: Response): Promise<Data> {
  try {
    const data = (await res.json()) as ExecutionResult<Data>

    if (!res.ok) {
      throw makeGraphServerError(res)
    }

    if (data.errors || !data.data) {
      throw makeGraphUserError<Data>(data)
    }

    return data.data
  } catch (error) {
    if (error instanceof ApplicationError) {
      throw error
    }

    throw new SystemError('Unhandled error processing graphql response', {
      originalError: error,
    })
  }
}
